var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-col-start-start gap-2 w-100"},_vm._l((8),function(i){return _c('v-skeleton-loader',{key:i,attrs:{"type":"image","width":"100%","height":"60"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }